import { icon_children, bigScreen_icon_children, app_icon_children } from "./menus/index"
import { getOptDes } from "./menus/optDes"
const cxIcon = {
  name: "cxIcon",
  desc: "图标样式",
  render: () => import("./render/index.vue"),
  optDes: getOptDes,
  enable: true,
  menus: {
    app: [
      {
        name: "图标",
        children: app_icon_children,
        group: "baseElement",
        sort: 50
      }
    ],
    bigScreen: [
      {
        name: "图标",
        children: bigScreen_icon_children,
        group: "element",
        sort: 50
      }
    ],
    portal: [
      {
        name: "图标",
        children: icon_children,
        group: "baseElement",
        sort: 50
      }
    ]
  },
  toolbars: [
    {
      name: "cxIcon",
      label: "图标",
      comp: {
        iconComponentData: () => import("./toolbars/icon-options-data.vue"),
        iconComponentSetting: () => import("./toolbars/icon-options-setting.vue"),
        iconComponentStyle: () => import("./toolbars/icon-options-style.vue")
      }
    }
  ]
}

export default cxIcon
